import { ID_ORIGIN } from '@api/origins';

export default {
    qrType: 'oauth-web',
    kpn: 'KS_OPEN_PLATFORM',
    qrBaseUrl: ID_ORIGIN,
    infraBaseUrl: '',
};
